<template lang="pug">
div
  #preloader(v-if="loading")
    #loader
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      loading: false
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
    appID() {
      return config.app_id;
    }
  },
  created() {
    var q = this.$route.query;
    this.paymentGateWaySubmit(q.amount, q.bank, q.promo, q.reloadPinCode, q.telcoCode);
  },
  methods: {
    paymentGateWaySubmit(deposit_amount, target_bank_id, package_id, reloadPinCode, telcoCode) {
      if(package_id === '0'){
        package_id = ""
      }  
      if (this.accountID && this.sessionToken) {
        this.loading = true
        let account_id = this.accountID;
        let auth_token = this.sessionToken;
        let app_id = config.app_id;
        this.$store
          .dispatch("user/winpay", {
            account_id,
            deposit_amount,
            target_bank_id,
            package_id,
            auth_token,
            app_id,
            reloadPinCode,
            telcoCode
          })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success;
            this.feedback.status = response.status;
            if (this.feedback.success == true) {
              var vm = this
              if(response.status == "OK"){
                var displayStatus = this.$t('message.processing')
              }else{
                var displayStatus = response.status
              }            
              this.$swal({
                title: vm.$tc("ui.attention"),
                confirmButtonText: "Close",
                text: displayStatus,
                type: "info"
              }).then(result => {
                window.close()
              });
            } else {
              var vm = this;
              if((typeof response.status) != 'object'){
                // this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
                this.$helpers.showDialog(vm.$tc("ui.attention"), response.status, "info", this);
              }
            }
          })
          .catch(response => {
            this.loading = false;
            this.feedback.success = false;
            var vm = this;
            if((typeof response.status) != 'object'){
              // this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
              this.$helpers.showDialog(vm.$tc("ui.attention"), response.status, "info", this);
            }
            // this.feedback.status = this.$t("error." + response.status);
          });
      }
    }
  }
};
</script>
